import styled from '@emotion/styled';
import { Tooltip, tooltipClasses, TooltipProps } from '@mui/material';
import { colors } from 'crono-fe-common/theme';

export const TemplateCardsContainerTooltip = styled(
  ({ className, ...props }: TooltipProps) => (
    <Tooltip
      arrow={props.arrow ? props.arrow : false}
      {...props}
      classes={{ popper: className }}
      placement="left"
    />
  ),
)(() => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: 'white',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 400,
    minWidth: 400,
    maxHeight: 600,
    border: `1px solid ${colors.templatesIconBlue}`,
    borderRadius: 16,
    marginBlock: 16,
    padding: 0,
    paddingBottom: 12,
    WebkitBoxShadow: '0px 4px 8px 4px rgba(0, 0, 0, 0.20)',
    MozBoxShadow: '0px 4px 8px 4px rgba(0, 0, 0, 0.20)',
    OBoxShadow: '0px 4px 8px 4px rgba(0, 0, 0, 0.20)',
    BoxShadow: '0px 4px 8px 4px rgba(0, 0, 0, 0.20)',
    overflow: 'hidden',
  },
}));
